export default {
  CHANGE_LOCALE (state, l) {
    state.locale = l
  },
  LOCATION (state, l) {
    state.location = l
  },
  program (state, data) {
    state.program = data
  },
  learning (state, data) {
    state.learning = data
  },
  journals (state, data) {
    state.journals = data
  },
  SINGLE (state, data) {
    state.single = data
  },
  ABOUT (state, data) {
    state.about = data
  },
  WEATHER (state, data) {
    state.weather = data
  },
  CLOSED (state, data) {
    state.closed = data
  },
  ARTICLE (state, data) {
    state.article = data
  },
  FEATURED (state, data) {
    state.featured = data
  },
  CURRENT (state, data) {
    state.current = data
  },
  NEWS (state, data) {
    state.news = data
  },
  NEWS_ITEM (state, data) {
    state.newsItem = data
  },
  BOOK (state, data) {
    state.book = data
  },
  BOOKS (state, data) {
    state.books = data
  },
  VISIT_PAGE (state, data) {
    state.visit = data
  },
  CONTENT_PAGE (state, { slug, data }) {
    state.pages = {
      ...state.pages,
      [slug]: data
    }
  },
  ENTITY (state, { id, data }) {
    state.entities = {
      ...state.entities,
      [id]: data
    }
  },

  SET_SEARCH_TERM (state, payload) {
    state.searchTerm = payload
  },
  SET_SEARCH_RESULTS (state, payload) {
    state.searchResults = payload
  },

  STYLE (state, data) {
    state.style = data
  },
  RESET_STYLE (state) {
    state.style = {
      color: 'black',
      backgroundColor: 'white'
    }
  },

  FROM_PAGE (state, str) {
    state.fromPage = str
  },
  FROM_LOCALE (state, str) {
    state.fromLoc = str
  },

  FIRST_VISIT (state, bool = true) {
    state.firstVisit = bool
  },

  HAS_MEDIA (state, bool) {
    state.hasMedia = bool
  },
  MUTE (state, bool) {
    state.mute = bool
  },
  TIME (state, payload) {
    state.time = payload
  }

}
